import React from 'react';
import { ServiceIncludesItem, ServiceIncludesList } from '../styled';
var AdvantagesList = function (_a) {
    var advantages = _a.advantages;
    return (<ServiceIncludesList>
            {advantages.map(function (advantage, index) { return (<ServiceIncludesItem key={index} dangerouslySetInnerHTML={{ __html: advantage }} data-test='adv-item'/>); })}
        </ServiceIncludesList>);
};
export default AdvantagesList;
